const normalizeGatewayHost = (host?: string) => {
  if (!host) return host as unknown as string;
  try {
    const url = new URL(host);
    const isBetaCluster = url.hostname.includes('beta-cluster.clarke.com.br');
    const isPlainGraphql = url.pathname === '/graphql';
    if (isBetaCluster && isPlainGraphql) {
      url.pathname = '/gateway/graphql';
      return url.toString();
    }
    return host;
  } catch {
    return host;
  }
};

const PRODUCTION_PUBLIC_PROPOSAL_BASE_URL = 'https://admin.clarke.com.br';
const PRODUCTION_CALCULATOR_NEW_API_HOST = 'https://prod-cluster.clarke.com.br/calculator-new';
const BETA_CALCULATOR_NEW_API_HOST = 'https://beta-cluster.clarke.com.br/calculator-new';
const BETA_PUBLIC_PROPOSAL_BASE_URL = 'https://beta-admin.clarke.com.br';

const trimTrailingSlash = (value?: string) => (value ?? '').trim().replace(/\/+$/, '');

const resolvePublicProposalBaseUrl = () => {
  const fromEnv = trimTrailingSlash(import.meta.env.VITE_PUBLIC_PROPOSAL_BASE_URL);
  if (fromEnv) return fromEnv;
  return String(import.meta.env.VITE_IS_IN_PRODUCTION) === 'true'
    ? PRODUCTION_PUBLIC_PROPOSAL_BASE_URL
    : BETA_PUBLIC_PROPOSAL_BASE_URL;
};

const configuration = {
  SERVER_PORT: import.meta.env.VITE_SERVER_PORT,
  GATEWAY_API_HOST: normalizeGatewayHost(import.meta.env.VITE_GATEWAY_API_HOST),
  AMPLITUDE_API_KEY: import.meta.env.VITE_AMPLITUDE_API_KEY,
  CUSTOMER_API_HOST: import.meta.env.VITE_CUSTOMER_API_HOST,
  AMPLITUDE_INITIALIZED: false,
  CLARITY_PROJECT_ID: import.meta.env.VITE_CLARITY_PROJECT_ID,
  IS_IN_PRODUCTION: import.meta.env.VITE_IS_IN_PRODUCTION,
  CALCULATOR_NEW_API_HOST:
    (/^https?:\/\//.test(trimTrailingSlash(import.meta.env.VITE_CALCULATOR_NEW_API_HOST))
      ? trimTrailingSlash(import.meta.env.VITE_CALCULATOR_NEW_API_HOST)
      : '') ||
    (String(import.meta.env.VITE_IS_IN_PRODUCTION) === 'true'
      ? PRODUCTION_CALCULATOR_NEW_API_HOST
      : BETA_CALCULATOR_NEW_API_HOST),
  PUBLIC_PROPOSAL_BASE_URL: resolvePublicProposalBaseUrl(),
  SELLER_CONTRACTS_ENABLED: String(import.meta.env.VITE_SELLER_CONTRACTS_ENABLED) === 'true',
};

if (!configuration.GATEWAY_API_HOST) {
  throw `Invalid GATEWAY_API_HOST! value found: ${configuration.GATEWAY_API_HOST}`;
}

export default configuration;
